import { cva } from "class-variance-authority";

import { STATUS_BADGE, SURFACE_BADGE } from "@/lib/status-colors";

export const badgeVariants = cva(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden border border-transparent px-1.5 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:ring-2 focus-visible:ring-ring has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 aria-invalid:border-destructive [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a]:hover:bg-primary/80",
        secondary: "bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80",
        destructive:
          "bg-destructive/10 text-destructive focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:focus-visible:ring-destructive/40 [a]:hover:bg-destructive/20",
        outline: "border-border text-foreground [a]:hover:bg-muted [a]:hover:text-muted-foreground",
        ghost: "hover:bg-muted hover:text-muted-foreground dark:hover:bg-muted/50",
        link: "text-primary underline-offset-4 hover:underline",
        // Non-status surfaces (transport mode, tool turns) borrow the neutral
        // and brand tokens so the semantic ramp stays reserved for run status.
        brand: SURFACE_BADGE.brand,
        neutral: SURFACE_BADGE.neutral,
        // Run, session and build status: the only semantic colors in the set.
        queued: STATUS_BADGE.queued,
        running: STATUS_BADGE.running,
        waiting: STATUS_BADGE.waiting,
        succeeded: STATUS_BADGE.succeeded,
        failed: STATUS_BADGE.failed,
        skipped: STATUS_BADGE.skipped,
        paused: STATUS_BADGE.paused,
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
